export default __webpack_public_path__ + "img/newsletter-plane-e44e2f88b87dc192e4ce47bb69ee0414.png";